import React from 'react';
import { Separator } from './ui/separator';
import { Mail, Linkedin, MessageCircle, Heart } from 'lucide-react';
import { mockData } from '../data/mock';

const Footer = () => {
  const { contact } = mockData;
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const footerLinks = [
    { label: 'Services', id: 'services' },
    { label: 'Portfolio', id: 'portfolio' },
    { label: 'Experience', id: 'experience' },
    { label: 'About', id: 'about' },
    { label: 'Contact', id: 'contact' }
  ];

  return (
    <footer className="bg-accent/30 border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-blue-600 dark:text-blue-500 mb-3">
              AI-Tech Solutions
            </h3>
            <p className="text-foreground/70 mb-4">
              Building AI-powered systems that save businesses time and money.
            </p>
            <div className="flex space-x-3">
              <a
                href={`mailto:${contact.email}`}
                className="p-2 bg-blue-600/10 hover:bg-blue-600 text-blue-600 hover:text-white rounded-lg transition-colors"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
              <a
                href={contact.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-blue-600/10 hover:bg-blue-600 text-blue-600 hover:text-white rounded-lg transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href={contact.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-blue-600/10 hover:bg-blue-600 text-blue-600 hover:text-white rounded-lg transition-colors"
                aria-label="WhatsApp"
              >
              <MessageCircle className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-foreground mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-foreground/70 hover:text-blue-600 transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-foreground mb-4">Services</h4>
            <ul className="space-y-2 text-foreground/70">
              <li>AI Automation</li>
              <li>Website Development</li>
              <li>Internal Tools</li>
              <li>Backend Systems</li>
            </ul>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-sm text-foreground/60 text-center md:text-left">
            © {currentYear} AI-Tech Solutions. All rights reserved.
          </p>
          <p className="text-sm text-foreground/60 flex items-center">
            Built with <Heart className="h-4 w-4 mx-1 text-red-500 fill-red-500" /> and cutting-edge technology
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;